import React, { useEffect, useRef } from 'react';
import { Animated, ScrollView, StyleSheet } from 'react-native';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import { ThemedView, ThemedText } from '@app/theme';
import CommonHeader from '@sharedComponents/Header/Header';

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const AnimatedShimmer = Animated.createAnimatedComponent(ShimmerPlaceholder);

const KYCStepperShimmer = ({isLoading}: {isLoading: boolean}) => {

    const fadeAnim = useRef(new Animated.Value(1)).current;

    useEffect(() => {
        if (isLoading) {
            // Start fade out animation when component mounts
            Animated.timing(fadeAnim, {
                toValue: 1,
            duration: 100,
            useNativeDriver: true,
            }).start();
        }
    }, [isLoading]);
    return (
        <Animated.View style={{ flex: 1  }}>

            <ThemedView flex={1}>
                <ThemedView flex={1} backgroundColor={'bg-surface-primary'}>
                    <ThemedView height={60} />

                    <ScrollView style={styles.container}>
                        {/* Steps remaining text shimmer */}
                        <AnimatedShimmer
                            style={[styles.stepsText , { opacity: fadeAnim }]}
                            
                            shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
                        />

                        {/* Credit limit card shimmer */}
                        <ThemedView style={styles.creditLimitCard}>
                            <AnimatedShimmer
                                style={[styles.creditLimitContent, { opacity: fadeAnim }]}
                                shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
                            />
                        </ThemedView>

                        {/* Stepper items shimmer */}
                        {[...Array(4)].map((_, index) => (
                            <ThemedView key={index} style={styles.stepperItem}>
                                <AnimatedShimmer
                                    style={[styles.stepperContent, { opacity: fadeAnim }]}
                                    shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
                                />
                            </ThemedView>
                        ))}
                    </ScrollView>

                    {/* Bottom button shimmer */}
                    <ThemedView style={styles.bottomContainer}>
                        <ThemedView style={styles.divider} />
                        <ThemedView style={styles.buttonContainer}>
                            <AnimatedShimmer
                                style={[styles.button, { opacity: fadeAnim }]}
                                shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
                            />
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
        </Animated.View>
    );
};

const styles = StyleSheet.create({
    container: {
        padding: 16,
        flex: 1,
    },
    stepsText: {
        width: '40%',
        height: 24,
        borderRadius: 4,
        marginTop: 8,
    },
    creditLimitCard: {
        marginTop: 16,
        borderRadius: 8,
        overflow: 'hidden',
    },
    creditLimitContent: {
        width: '100%',
        height: 90,
        borderRadius: 8,
    },
    stepperItem: {
        marginTop: 16,
        borderRadius: 8,
        overflow: 'hidden',
    },
    stepperContent: {
        width: '100%',
        height: 60,
        borderRadius: 8,
    },
    bottomContainer: {
        justifyContent: 'flex-end',
        bottom: 0,
    },
    divider: {
        height: 1,
        backgroundColor: '#E4E7EC',
    },
    buttonContainer: {
        padding: 16,
    },
    button: {
        width: '100%',
        height: 48,
        borderRadius: 8,
    },
});

export default KYCStepperShimmer;